import React from "react";
import styled from "styled-components";
import ModuleHeroImage from "../../assets/image/video_banner.png";
import ResourcesDownloadCCSS from "../../components/MyInfo/ResourcesDownloadCCSS";
import CCSSDownload from "../../components/MyInfo/CCSSDownload";
import { DOCS_BASE_URL } from "../../util/constant";

const breakpoints = {
  tablet: 768,
  phone: 480,
};

const CCSS_DOCS_BASE_URL = `${DOCS_BASE_URL}/ccss/`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  min-height: 72vh;

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    padding: 12px;
  }
`;

const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 320px) 1fr;
  gap: 20px;
  width: 100%;
  max-width: 1200px;

  @media (max-width: ${breakpoints.tablet}px) {
    grid-template-columns: 1fr;
  }
`;

const sidebarLinks = [
  {
    label: (
      <>
        - Implementation Strategy
      </>
    ),
    href: `${DOCS_BASE_URL}/Implementation_Strategy-2025-2026.pdf`,
  },
  {
    label: "E-Rate Internet Safety Education Certificate - Download",
    href: "/myinfo/pdf",
    isCertificate: true,
  },
  {
    label: "Module Names Conversion",
    href: `${DOCS_BASE_URL}/module-names-conversion-chart.pdf`,
  },
];

const standardsResources = [
  { description: "Grade K - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_GradeK_E-Rate.xlsx` },
  { description: "Grade K - Non-E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_GradeK_E-Safety.xlsx` },
  { description: "Grade 1 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade1_E-Rate.xlsx` },
  { description: "Grade 1 - Non-E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade1_E-Safety.xlsx` },
  { description: "Grade 2 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade2_E-Rate.xlsx` },
  { description: "Grade 2 - Non-E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade2_E-Safety.xlsx` },
  { description: "Grade 3 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade3_E-Rate.xlsx` },
  { description: "Grade 3 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade3_E-Safety_part1.xlsx` },
  { description: "Grade 3 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade3_E-Safety_part2.xlsx` },
  { description: "Grade 4 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade4_E-Rate.xlsx` },
  { description: "Grade 4 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade4_E-Safety_part1.xlsx` },
  { description: "Grade 4 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade4_E-Safety_part2.xlsx` },
  { description: "Grade 5 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade5_E-Rate.xlsx` },
  { description: "Grade 5 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade5_E-Safety_part1.xlsx` },
  { description: "Grade 5 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade5_E-Safety_part2.xlsx` },
  { description: "Grade 5 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade5_E-Safety_part3.xlsx` },
  { description: "Grade 6 - E-Rate AOB CB", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade6_E-Rate_AOB_CB.xlsx` },
  { description: "Grade 6 - E-Rate SN", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade6_E-Rate_SN.xlsx` },
  { description: "Grade 6 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade6_E-Safety_part1.xlsx` },
  { description: "Grade 6 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade6_E-Safety_part2.xlsx` },
  { description: "Grade 6 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade6_E-Safety_part3.xlsx` },
  { description: "Grade 7 - E-Rate AOB CB", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade7_E-Rate_AOB_CB.xlsx` },
  { description: "Grade 7 - E-Rate SN", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade7_E-Rate_SN.xlsx` },
  { description: "Grade 7 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade7_E-Safety_part1.xlsx` },
  { description: "Grade 7 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade7_E-Safety_part2.xlsx` },
  { description: "Grade 7 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade7_E-Safety_part3.xlsx` },
  { description: "Grade 8 - E-Rate AOB CB", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade8_E-Rate_AOB_CB.xlsx` },
  { description: "Grade 8 - E-Rate SN", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade8_E-Rate_SN.xlsx` },
  { description: "Grade 8 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade8_E-Safety_part1.xlsx` },
  { description: "Grade 8 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade8_E-Safety_part2.xlsx` },
  { description: "Grade 8 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade8_E-Safety_part3.xlsx` },
  { description: "Grade 9-10 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades9-10_E-Rate.xlsx` },
  { description: "Grade 9-10 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade9-10_E-Safety_part1.xlsx` },
  { description: "Grade 9-10 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades9-10_E-Safety_part2.xlsx` },
  { description: "Grade 9-10 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades9-10_E-Safety_part3.xlsx` },
  { description: "Grade 11-12 - E-Rate", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades11-12_E-Rate.xlsx` },
  { description: "Grade 11-12 - Non-E-Rate PART1", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grade11-12_E-Safety_part1.xlsx` },
  { description: "Grade 11-12 - Non-E-Rate PART2", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades11-12_E-Safety_part2.xlsx` },
  { description: "Grade 11-12 - Non-E-Rate PART3", href: `${CCSS_DOCS_BASE_URL}CCSStdrds_Grades11-12_E-Safety_part3.xlsx` },
];

const CCSSPage = ({ colors }) => {
  return (
    <PageContainer>
      <ContentLayout>
        <ResourcesDownloadCCSS colors={colors} links={sidebarLinks} />
        <CCSSDownload colors={colors} heroImage={ModuleHeroImage} resources={standardsResources} />
      </ContentLayout>
    </PageContainer>
  );
};

export default CCSSPage;
